import { motion } from "framer-motion";
import { SEOHead } from "@/components/shared/SEOHead";

export default function ImpressumPage() {
  return (
    <div className="pt-24 pb-20">
      <SEOHead
        title="Impressum | Freitag-Gruppe Braunschweig"
        description="Impressum der Bauunternehmung Freitag GmbH, Hinter dem Turme 29, 38114 Braunschweig. Geschäftsführer Uwe Freitag."
        canonical="/impressum"
        noindex={true}
      />
      <div className="container-wide">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="max-w-3xl"
        >
          <div className="w-12 h-1 gradient-blue mb-8" />
          <h1 className="font-heading font-bold text-4xl sm:text-5xl text-foreground mb-12">
            Impressum
          </h1>

          <div className="space-y-10">
            {/* Angaben */}
            <section>
              <h2 className="font-heading font-semibold text-lg text-foreground mb-4">
                {"Angaben gem\u00e4\u00df \u00a7 5 DDG"}
              </h2>
              <div className="text-sm text-muted-foreground font-body leading-relaxed space-y-1">
                <p className="text-foreground font-semibold">Bauunternehmung Freitag GmbH</p>
                <p>Hinter dem Turme 29</p>
                <p>38114 Braunschweig</p>
                <p>Deutschland</p>
              </div>
            </section>

            {/* Vertreten durch */}
            <section>
              <h2 className="font-heading font-semibold text-lg text-foreground mb-4">
                Vertreten durch:
              </h2>
              <div className="text-sm text-muted-foreground font-body leading-relaxed space-y-1">
                {"Gesch\u00e4ftsf\u00fchrer Uwe Freitag"}
                <br />
                Dipl. Immobilienwirt (EIA), Bautechniker
              </div>
            </section>

            {/* Kontakt */}
            <section>
              <h2 className="font-heading font-semibold text-lg text-foreground mb-4">
                Kontakt
              </h2>
              <div className="text-sm text-muted-foreground font-body leading-relaxed space-y-1">
                <p>Telefon: +49 (0) 531 87 46 10</p>
                <p>E-Mail: info@freitag-bs.de</p>
              </div>
            </section>

            {/* Registereintrag */}
            <section>
              <h2 className="font-heading font-semibold text-lg text-foreground mb-4">
                Registereintrag
              </h2>
              <div className="text-sm text-muted-foreground font-body leading-relaxed space-y-1">
                <p>Eintragung im Handelsregister</p>
                <p>Registergericht: Amtsgericht Braunschweig</p>
                <p>Registernummer: HRB 4991</p>
                <p className="mt-3">Str.-Nr.: 13/206/40203</p>
              </div>
            </section>

            {/* Mitgliedschaften */}
            <section>
              <h2 className="font-heading font-semibold text-lg text-foreground mb-4">
                Mitgliedschaften
              </h2>
              <div className="text-sm text-muted-foreground font-body leading-relaxed space-y-1">
                {"Mitglied im Bundesverband Deutscher Sachverst\u00e4ndiger des Handwerks e.V."}
                <br />
                {"Mitglied der Handwerkskammer Braunschweig-L\u00fcneburg-Stade"}
                <br />
                Mitglied der Industrie- und Handelskammer Braunschweig
              </div>
            </section>

            {/* Tätigkeitsbereiche */}
            <section>
              <h2 className="font-heading font-semibold text-lg text-foreground mb-4">
                {"T\u00e4tigkeitsbereiche der Freitag-Gruppe"}
              </h2>
              <div className="text-sm text-muted-foreground font-body leading-relaxed space-y-1">
                <p>Bauunternehmung</p>
                <p>Garten- und Landschaftsbau</p>
                {"Sachverst\u00e4ndigenb\u00fcro"}
              </div>
            </section>

            {/* Verantwortlich */}
            <section>
              <h2 className="font-heading font-semibold text-lg text-foreground mb-4">
                {"Verantwortlich f\u00fcr den Inhalt nach \u00a7 18 Abs. 2 MStV"}
              </h2>
              <div className="text-sm text-muted-foreground font-body leading-relaxed space-y-1">
                <p>Uwe Freitag</p>
                <p>Hinter dem Turme 29</p>
                <p>38114 Braunschweig</p>
              </div>
            </section>

            <div className="w-full h-px bg-border" />

            {/* Haftung für Inhalte */}
            <section>
              <h2 className="font-heading font-semibold text-lg text-foreground mb-4">
                {"Haftung f\u00fcr Inhalte"}
              </h2>
              <p className="text-sm text-muted-foreground font-body leading-relaxed">
                {"Als Diensteanbieter sind wir f\u00fcr eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. F\u00fcr die Richtigkeit, Vollst\u00e4ndigkeit und Aktualit\u00e4t der Inhalte \u00fcbernehmen wir jedoch keine Gew\u00e4hr."}
              </p>
            </section>

            {/* Haftung für Links */}
            <section>
              <h2 className="font-heading font-semibold text-lg text-foreground mb-4">
                {"Haftung f\u00fcr Links"}
              </h2>
              <p className="text-sm text-muted-foreground font-body leading-relaxed">
                {"Unsere Webseite enth\u00e4lt Links zu externen Webseiten Dritter. Auf deren Inhalte haben wir keinen Einfluss. Deshalb k\u00f6nnen wir f\u00fcr diese fremden Inhalte keine Gew\u00e4hr \u00fcbernehmen. F\u00fcr die Inhalte der verlinkten Seiten ist immer der jeweilige Anbieter oder Betreiber verantwortlich. Sollten uns Rechtsverletzungen bekannt werden, entfernen wir entsprechende Links umgehend."}
              </p>
            </section>

            {/* Urheberrecht */}
            <section>
              <h2 className="font-heading font-semibold text-lg text-foreground mb-4">
                Urheberrecht
              </h2>
              <p className="text-sm text-muted-foreground font-body leading-relaxed">
                {"Die auf dieser Webseite erstellten Inhalte und Werke unterliegen dem deutschen Urheberrecht. Jede Vervielf\u00e4ltigung, Bearbeitung, Verbreitung oder Verwertung au\u00dferhalb der Grenzen des Urheberrechts bedarf der vorherigen schriftlichen Zustimmung des jeweiligen Rechteinhabers."}
              </p>
            </section>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
